import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

type SharedChannelsPayload = {
  botId: string;
  conversationId: string;
  message: string;
  dealer?: boolean;
};

type ComputedBodyAttributes = {
  dealershipCode: string;
  corporateName: string;
};

type SendEmailPayload = {
  channel: 'email';
  fromEmail: { address: string | null; name: string | null } | null;
  subject: string;
  toEmail: string | null;
};

type SendSMSPayload = {
  channel: 'sms';
  fromNumber: string;
  toNumber: string;
};

export type SendMessagePayload = SharedChannelsPayload & (SendEmailPayload | SendSMSPayload);

type SharedChannelBody = SendMessagePayload & ComputedBodyAttributes;

const createEmailBody = (args): SharedChannelBody => {
  const { fromEmail: orgFromEmail } = args;
  const fromEmail = {
    address: orgFromEmail ? orgFromEmail.address : null,
    name: orgFromEmail ? orgFromEmail.name : null,
  };

  return { ...args, fromEmail };
};

const createSMSBody = args => {
  const { message, ...rest } = args;
  return { body: message, ...rest };
};
@Injectable({
  providedIn: 'root',
})
export class BachService {
  private bachSendMessageUrl: string;
  // temporarly commenting after check an issue on production on PR https://github.com/Revmaker/platform-ui/pull/655
  // private platformApiSendMessageUrl: string;

  constructor(private http: HttpClient) {
    // temporarly commenting after check an issue on production on PR https://github.com/Revmaker/platform-ui/pull/655
    //this.platformApiSendMessageUrl = environment.platformApi.url + '/send-message';
    this.bachSendMessageUrl = environment.bach.url + 'send-message'; //NOT OK
  }

  async sendConversationMessage(args: SendMessagePayload) {
    const { botId, channel } = args;
    const botComponents = botId.split('-');
    let dealershipCode = botComponents[0] + '-' + botComponents[1];
    if (botComponents.length === 4) {
      dealershipCode += '-' + botComponents[2];
    }
    if (botComponents.length === 5) {
      dealershipCode += '-' + botComponents[3];
    }

    const corporateName = botComponents[0];

    const computedAttributes: ComputedBodyAttributes = { corporateName, dealershipCode };

    const body =
      channel === 'email' ? createEmailBody({ ...args, ...computedAttributes }) : createSMSBody({ ...args, ...computedAttributes } as SharedChannelBody);

    const result = await firstValueFrom(this.http.post(this.bachSendMessageUrl, body))
      .then(data => {
        return data;
      })
      .catch(error => {
        console.log(error);
      });
    return result;
  }
}
